import React from "react";
// ANT DESIGN COMPONENTS
import { InputNumber, Select, Switch } from "antd";
// FLATBUFFER ENUMS
import { RedundancySupport } from "../../../../../flatbuffers/generated/opc-ua/redundancy-support";
// INTERFACES
import type { OpcUaRedundancyForm } from "../../../../../interfaces/AdapterCdoOpcUa.interface";

const { Option } = Select;

export const BLANK_REDUNDANCY: OpcUaRedundancyForm = {
  mode: RedundancySupport.None_,
  failoverTimeoutMs: 5000,
};

const REDUNDANCY_MODE_OPTIONS: { value: RedundancySupport; label: string }[] = [
  { value: RedundancySupport.None_, label: "None" },
  { value: RedundancySupport.Cold, label: "Cold" },
  { value: RedundancySupport.Warm, label: "Warm" },
  { value: RedundancySupport.Hot, label: "Hot" },
  { value: RedundancySupport.Transparent, label: "Transparent" },
  { value: RedundancySupport.HotAndMirrored, label: "Hot and Mirrored" },
];

/** Redundant-server failover configuration. Optional — a switch toggles between no redundancy (null) and an explicit config. */
export default function RedundancyEditor({
  redundancy,
  onChangeRedundancy,
}: {
  redundancy: OpcUaRedundancyForm | null;
  onChangeRedundancy: (redundancy: OpcUaRedundancyForm | null) => void;
}) {
  const onToggleEnabled = (enabled: boolean) =>
    onChangeRedundancy(enabled ? { ...BLANK_REDUNDANCY } : null);
  const onChangeField = <K extends keyof OpcUaRedundancyForm>(
    field: K,
    value: OpcUaRedundancyForm[K],
  ) => {
    onChangeRedundancy({ ...(redundancy ?? BLANK_REDUNDANCY), [field]: value });
  };

  return (
    <div className="container mt-3">
      <div className="generalStyles__flex" style={{ marginBottom: 16 }}>
        <span className="generalStyles__inputLabel">Configure redundancy</span>
        <Switch
          checked={redundancy !== null}
          onChange={onToggleEnabled}
          style={{ marginLeft: 8 }}
        />
      </div>
      {redundancy && (
        <div className="row">
          <div className="col-12 col-md-4 mt-2">
            <span className="generalStyles__inputLabel">Redundancy Mode</span>
            <Select
              className="generalStyles__width100"
              size="large"
              value={redundancy.mode}
              onChange={(v: RedundancySupport) => onChangeField("mode", v)}
            >
              {REDUNDANCY_MODE_OPTIONS.map((opt) => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-12 col-md-4 mt-2">
            <span className="generalStyles__inputLabel">Failover Timeout (ms)</span>
            <InputNumber
              className="generalStyles__width100"
              size="large"
              min={0}
              value={redundancy.failoverTimeoutMs}
              onChange={(v) => onChangeField("failoverTimeoutMs", v ?? 0)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
